import { WENCO_PAGE } from "features/projects/wencoPageRegistry";

/** Mandant Wenco GmbH & Co. KG */
export const WENCO_LOGISTIC_COMPANY_ID = 213;

/**
 * Kundenspezifische Projekte (Sidebar-Sektion „Projekte").
 * Schlüssel = logisticcompany_id des aktiven Mandanten.
 * pageKey = auth-gated Bundle (siehe wencoPageRegistry) — nie public/-URL.
 */
export const PLATFORM_PROJECTS_BY_COMPANY_ID = {
  [WENCO_LOGISTIC_COMPANY_ID]: [
    // {
    //   key: "project-pilot-tourenoptimierung-1",
    //   label: "Pilot Tourenoptimierung",
    //   title: "Pilot Tourenoptimierung",
    //   icon: "route",
    //   path: "/projects/pilot-tourenoptimierung-1",
    //   pageKey: WENCO_PAGE.PILOT_TOURENOPTIMIERUNG_1,
    //   badge: "Test"
    // },
    {
      key: "project-pilot-tourenoptimierung",
      label: "Tourenoptimierung",
      title: "Tourenoptimierung",
      icon: "route",
      path: "/projects/pilot-tourenoptimierung",
      pageKey: WENCO_PAGE.PILOT_TOURENOPTIMIERUNG,
      badge: "PoC#1",
      headerContext: "Tourenoptimierung - Proof of Concept #1"
    }
  ]
};

export const getProjectsForCompany = logisticCompanyId =>
  PLATFORM_PROJECTS_BY_COMPANY_ID[logisticCompanyId] || [];

export const findProjectByKey = projectKey => {
  const companies = Object.values(PLATFORM_PROJECTS_BY_COMPANY_ID);
  for (let i = 0; i < companies.length; i += 1) {
    const match = companies[i].find(project => project.key === projectKey);
    if (match) {
      return match;
    }
  }
  return null;
};

export const findProjectByPath = pathname => {
  const companies = Object.values(PLATFORM_PROJECTS_BY_COMPANY_ID);
  for (let i = 0; i < companies.length; i += 1) {
    const match = companies[i].find(
      project => pathname === project.path || pathname.startsWith(`${project.path}/`)
    );
    if (match) {
      return match;
    }
  }
  return null;
};

export const isProjectAllowedForCompany = (project, logisticCompanyId) => {
  if (!project) {
    return false;
  }
  const allowed = getProjectsForCompany(logisticCompanyId);
  return allowed.some(item => item.key === project.key);
};
